import React, { useEffect, useState } from 'react';
import './RequestLists.scss';
import { Tabs, Table, Avatar, Button, Tag, Space, Modal, Input } from 'antd';
import { PlusOutlined, EyeOutlined, ExclamationCircleOutlined, SearchOutlined, UploadOutlined } from "@ant-design/icons";
import SimpleButton from '../../../components/buttons/simpleButton/SimpleButton';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { appDispatch, RootState } from '../../../app/store';
import { acceptOrRejectRequest, deleteONUserRequest, fetchRequestLists, licenseApproveOrReject, editLicense, fetchONUserDetails } from '../../../features/superAdmin/requestLIsts/requestListsSlice';
import { toast } from 'react-toastify';
import { Skeleton, Card } from 'antd';
import { UserDetailsModal } from './components/userDetailsModal';
import { DEFAULT_PROFILE_IMAGE, SUPER_ADMIN_API_URL } from '../../../constants';
import { fetchNotesList } from '../../../features/users/usersSlice';

interface UserData {
  key: string;
  name: string;
  email: string;
  status: string;
  avatar: string;
}

export const RequestLists = () => {

  const navigate = useNavigate()
  const { confirm } = Modal;
  const dispatch = useDispatch<appDispatch>();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [pageNumber, setPageNumber] = useState<any>(1);
  const [totalCount, setTotalCount] = useState<any>(1);
  const [activeTab, setActiveTab] = useState<string>('approval');
  const [searchQuery, setSearchQuery] = useState<string>('');



  const {
      requestListData,
      isLoading
  } = useSelector((state: RootState) => state.requestLsts.fetchRequestLists);

  const {
    userDetailsData,
    isLoading:isUserDetailsLoading,
  } = useSelector((state: RootState) => state.requestLsts.fetchONUserDetails);


  // Extract total count from API response
  useEffect(() => {
    if (requestListData && requestListData?.total !== undefined) {
      setTotalCount(requestListData?.total);
    }
  }, [requestListData]);

  useEffect(()=>{
    console.log("test res userDetailsData",userDetailsData)
  },[userDetailsData])

  const {
    isLoading: isLicenseActionLoading,
  } = useSelector((state: RootState) => state.requestLsts.licenseApproveOrReject);

  const {
    isLoading: isEditLicenseLoading,
  } = useSelector((state: RootState) => state.requestLsts.editLicense);

  const TABS = [
    { label: 'Approval Requests', key: 'approval', status: 'pending' },
    { label: 'Approved Requests', key: 'approved', status: 'approved' },
    { label: 'Rejected Requests', key: 'rejected', status: 'rejected' },
  ];
  
  useEffect(()=>{
    const currentTab = TABS.find(tab => tab.key === activeTab);
    if (currentTab) {
      dispatch(fetchRequestLists({searchQuery: "", status: currentTab.status, page: 1}))
    }
  },[activeTab, searchQuery])

  const handleTabChange = (key: string) => {
    setActiveTab(key);
    setPageNumber(1);
  };

  const handleSearch = (value: string) => {
    setSearchQuery(value);
    setPageNumber(1);
    const currentTab = TABS.find(tab => tab.key === activeTab);
    if (currentTab) {
      dispatch(fetchRequestLists({searchQuery: value, status: currentTab.status, page: 1}))
    }
  };

  const handlePageChange = (page: number) => {
    setPageNumber(page);
    const currentTab = TABS.find(tab => tab.key === activeTab);
    if (currentTab) {
      dispatch(fetchRequestLists({searchQuery: searchQuery, status: currentTab.status, page: page}))
    }
  };

  const handleViewDetails = async (user: any) => {
      // const params = { id: user?.id };  // <-- wrap in { id }
    await dispatch(fetchNotesList({ id: user?.id }));
    const response = await dispatch(fetchONUserDetails(user?.id))
   
    if(response?.payload?.isSuccess){
      setSelectedUser(user);
      setIsModalVisible(true);
    }
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
    setSelectedUser(null);
  };

  const handleEditUserRequest = (user: any) => {
    // setSelectedUser(user);
    // setIsModalVisible(true);
    navigate("/superadmin/request-lists/add-user",{state:{
      isEditMode:true,
      userId:user?.id
    }})
  }

  const handleDeleteUserRequest = (user: any) => {
    confirm({
      title: 'Delete confirmation',
      icon: <ExclamationCircleOutlined />,
      content: 'Are you sure you want to delete?',
      centered: true,
      onOk() {
        // dispatch(deleteONUserRequest({id:user?.id}))
      },
      onCancel() { },
    });
  }

  const handleVerifyLicense = async (user: any, licenseIndex: number) => {
    try {
      const payload = {
        medical_licenses: user.medical_licenses.map((lic: any, idx: number) => ({
          license_number: lic.license_number,
          is_valid: idx === licenseIndex ? true : Boolean(lic.is_valid),
          validation_status: idx === licenseIndex ? "APPROVED" : (lic.validation_status || ""),
          ...(idx === licenseIndex && lic.comment ? { comment: lic.comment } : {}),
          country: {
            name: lic.country.name,
            country_name_code: lic.country.country_name_code
          },
          issuing_state: {
            name: lic.issuing_state.name,
            state_code: lic.issuing_state.state_code
          }
        }))
      };

      const response = await dispatch(licenseApproveOrReject({payload,userId:user?.id}));
      if (response?.payload?.isSuccess) {
        // Refresh the user details to get the updated license status
        await dispatch(fetchONUserDetails(user?.id));
        toast.success(response?.payload?.message || `License #${licenseIndex + 1} verified`);
      } else {
        toast.error(response?.payload || 'Failed to verify license');
      }
    } catch (e) {
      toast.error('Failed to verify license');
    }
  };

  const handleRejectLicense = async (user: any, licenseIndex: number, reason: string) => {
    try {
      const payload = {
        medical_licenses: user.medical_licenses.map((lic: any, idx: number) => ({
          license_number: lic.license_number,
          is_valid: idx === licenseIndex ? false : Boolean(lic.is_valid),
          validation_status: idx === licenseIndex ? "REJECTED" : (lic.validation_status || ""),
          ...(idx === licenseIndex ? { comment: reason } : (lic.comment ? { comment: lic.comment } : {})),
          country: {
            name: lic.country.name,
            country_name_code: lic.country.country_name_code
          },
          issuing_state: {
            name: lic.issuing_state.name,
            state_code: lic.issuing_state.state_code
          }
        }))
      };

      const response = await dispatch(licenseApproveOrReject({payload,userId:user?.id}));
      if (response?.payload?.isSuccess) {
        // Refresh the user details to get the updated license status
        await dispatch(fetchONUserDetails(user?.id));
        toast.success(response?.payload?.message || `License #${licenseIndex + 1} rejected`);
      } else {
        toast.error(response?.payload || 'Failed to reject license');
      }
    } catch (e) {
      toast.error('Failed to reject license');
    }
  };

  const handleEditLicense = (user: any, licenseIndex: number, updatedLicense: any) => {
    try {
      setSelectedUser((prev: any) => {
        if (!prev) return prev;
        const updated = { ...prev };
        if (updated.medical_licenses && updated.medical_licenses[licenseIndex]) {
          updated.medical_licenses = [...updated.medical_licenses];
          updated.medical_licenses[licenseIndex] = {
            ...updated.medical_licenses[licenseIndex],
            ...updatedLicense,
          };
        }
        return updated;
      });
      toast.success(`License #${licenseIndex + 1} updated`);
    } catch (e) {
      toast.error('Failed to update license');
    }
  };

  const handleSaveLicense = async (user: any, licenseIndex: number, updatedLicense: any) => {
    try {
      const payload = {
        payload:{
        medical_licenses: [updatedLicense]
      },
      userId:user?.id
    }

      const response = await dispatch(editLicense(payload));
      if (response?.payload?.isSuccess) {
        // Refresh the user details to get the updated license
        await dispatch(fetchONUserDetails(user?.id));
        toast.success(response?.payload?.message || `License #${licenseIndex + 1} saved successfully`);
      } else {
        toast.error(response?.payload || 'Failed to save license');
      }
    } catch (e) {
      toast.error('Failed to save license');
    }
  };

  const handleRequestAccept = async (user: any,isApprove: boolean,Reason?:string) => {
    const approvePayload = {
      payload:{
        "approval_status": "APPROVED"
      },
      id:user?.id
    }
    const rejectPayload = {
      payload:{
        "approval_status": "REJECTED",
        "comment": Reason ?? ""
      },
      id:user?.id
    }
    const response = await dispatch(acceptOrRejectRequest(isApprove ? approvePayload : rejectPayload))
    console.log("test res response",response)
    if(response?.payload?.isSuccess){
      toast.success(response?.payload?.message)
      handleModalClose();
      // Refresh the current tab data
      const currentTab = TABS.find(tab => tab.key === activeTab);
      if (currentTab) {
        dispatch(fetchRequestLists({searchQuery: searchQuery, status: currentTab.status, page: pageNumber}))
      }
    }else{
      toast.error(response?.payload)
    }
  }

  const displayImage = (imageUrl: string | undefined) => {
    if (!imageUrl || imageUrl.trim() === "") {
      return DEFAULT_PROFILE_IMAGE;
    }
    return `${SUPER_ADMIN_API_URL}${imageUrl}`;
  }

  const getStatusColor = (status: string) => {
    switch (status.toLowerCase()) {
      case 'pending':
        return 'orange';
      case 'approved':
        return 'green';
      case 'rejected':
        return 'red';
      case 'deleted':
        return 'default';
      default:
        return 'blue';
    }
  }

  const columns = [
    {
      title: 'User',
      key: 'display_name',
      render: (_: any, record: any) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Avatar size={32} src={record.profile_pic ?? DEFAULT_PROFILE_IMAGE} alt={record.display_name} />
          <div>
            <div style={{ fontWeight: 500, fontSize: 13 }}>{record.display_name}</div>
          </div>
        </div>
      ),
    },
    {
      title: 'Email',
      key: 'email',
      dataIndex: 'email',
      render: (email: string) => (
        <span style={{ color: "var(--common-black-white)", fontSize: 13 }}>{email}</span>
      ),
    },
    {
      title: 'Status',
      key: 'approval_status',
      render: (_: any, record: any) => (
        <Tag color={getStatusColor(record.approval_status)} style={{ fontSize: 12 }}>{record.approval_status}</Tag>
      ),
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_: any, record: UserData) => (
        <Button 
          type="primary" 
          size="small"
          icon={<EyeOutlined />}
          style={{ fontSize: 12, height: 28 }}
          onClick={() => handleViewDetails(record)}
        >
          View
        </Button>
      ),
    },
  ];

  const renderTableContent = () => {
    return (
      <div>
        <Table 
          columns={columns} 
          dataSource={requestListData?.data||[]} 
          pagination={{
                position: ["bottomRight"],
                pageSize: requestListData?.per_page,
                current: pageNumber,
                onChange: (page) => handlePageChange(page),
                total: totalCount,
                showSizeChanger: false,
                showQuickJumper: true,
                showTotal: (total, range) => (
                  <div className="pagniation-text">
                    {`${range[0]}-${range[1]} of ${total} items`}
                  </div>
                ),
              }
          }
          rowKey="id"
          size="small"
          style={{ fontSize: 13 }}
        />
      </div>
    );
  };

  const tabItems = TABS.map(tab => ({
    label: tab.label,
    key: tab.key,
    children: isLoading ? (
      <div style={{ padding: '20px' }}>
        <Skeleton active paragraph={{ rows: 8 }} />
      </div>
    ) : (
      renderTableContent()
    ),
  }));

  const handleAddUser = () =>{
    navigate("/superadmin/request-lists/add-user",{state:{
      isEditMode:false,
    }})
  }

  return (
    <div className="request-lists-container">
      <Tabs
        items={tabItems}
        defaultActiveKey="approval"
        activeKey={activeTab}
        onChange={handleTabChange}
        className="request-lists-tabs"
        tabBarExtraContent={
          <div className="register-user-btn-wrapper">
            <SimpleButton onClick={handleAddUser} text='Add User' icon={<PlusOutlined />} color="secondary" />
            <SimpleButton onClick={()=>navigate("/superadmin/request-lists/upload-users")} text='Upload Users' icon={<UploadOutlined />} color="primary" />
          </div>
        }
      />
      
      <UserDetailsModal
        isVisible={isModalVisible&&userDetailsData}
        // user={selectedUser}
        user={userDetailsData}
        onClose={handleModalClose}
        onAccept={handleRequestAccept}
        onReject={handleRequestAccept}
        currentTab={activeTab}
        onEdit={handleEditUserRequest}
        onDelete={handleDeleteUserRequest}
        onVerifyLicense={handleVerifyLicense}
        onRejectLicense={handleRejectLicense}
        onEditLicense={handleEditLicense}
        onSaveLicense={handleSaveLicense}
        isLicenseActionLoading={isLicenseActionLoading}
        isEditLicenseLoading={isEditLicenseLoading}
      />
    </div>
  );
}
